import type { PaneComponentProps } from "@hq/layout";
import { EmptyState } from "@z/ui";
import { CalendarDays } from "lucide-react";

/** Placeholder until M3 (read-only Google Calendar sync and the FullCalendar view). */
export function CalendarPane(_props: PaneComponentProps) {
  return (
    <EmptyState
      className="h-full"
      icon={<CalendarDays className="size-6" />}
      title="Calendar is coming soon"
      description="External calendars, scheduled tasks on a week grid, and drag-to-schedule from the task list."
    />
  );
}
